import { Component, PLATFORM_ID, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SupabaseService } from '@app/core/services';
// ** service
import { LayoutService } from '@app/core/services/layout.service';
// ** rxjs
import { finalize, switchMap, tap } from 'rxjs/operators';
import { of, Observable, from } from 'rxjs';

@Component({
	selector: 'app-group-break-list',
	templateUrl: './group-break-list.component.html',
	styleUrls: ['./group-break-list.component.scss'],
})
export class GroupBreakListComponent implements OnInit {
	// 團拆列表 - 動態從 Supabase 抓取，不寫死
	groupBreakList = [];
	// 周邊商品列表 - 同一張 Products 表，依 type 欄位分出來
	merchList = [];

	constructor(
		@Inject(DOCUMENT) private document: Document,
		@Inject(PLATFORM_ID) private platformId,
		private supabaseService: SupabaseService,
		public layoutService: LayoutService
	) {}

	ngOnInit(): void {
		const canonical = this.document.querySelector('link[rel="canonical"]') as HTMLAnchorElement | null;
		if (canonical) canonical.href = 'https://bigaunt666.github.io/bigaunt/products';

		of(this.layoutService.setPageLoading(true))
			.pipe(
				switchMap(() => this.getGroupBreakList$()),
				finalize(() => this.layoutService.setPageLoading(false))
			)
			.subscribe();
	}

	getGroupBreakList$(): Observable<any> {
		return from(this.supabaseService.getGroupBreaks()).pipe(
			tap(({ data }) => {
				const productList = data || [];
				this.groupBreakList = productList.filter((item) => item.type === 'GroupBreaks');
				this.merchList = productList.filter((item) => item.type === 'Merch');
			})
		);
	}
}
